/* eslint-disable import/no-named-as-default */
import React, { FunctionComponent } from "react";
import { Provider } from "react-redux";
import PropTypes from "prop-types";
import store from "../../store";
import AgencyPerformanceMetrics from "./AgencyPerformanceMetrics";

interface IProviderComponentProps {
  recruiterId: number;
}

const ProviderComponent: FunctionComponent<IProviderComponentProps> = ({
  recruiterId,
}) => (
  <Provider store={store}>
    <AgencyPerformanceMetrics recruiterId={recruiterId} />
  </Provider>
);

ProviderComponent.propTypes = {
  recruiterId: PropTypes.number.isRequired,
};

export default ProviderComponent;
